import React, { useState, useEffect,useRef, use } from "react";
import { Provider } from "react-redux";
import { ReactKeycloakProvider } from "@react-keycloak/web";
import { message } from "antd";

import getKeycloakInstance from "./core/auth/keycloak"; 

import { store } from "./redux/store";
import RoutesComponent from "./routes/RoutesComponent";
import AppContent from "./AppContent";
import logger from "./core/utils/logger";
import CookieConsent from "./components/CookieConsent";
import { ThemeProvider } from "./contexts/ThemeContext";
import "./styles/notifications.css";



const keycloak = getKeycloakInstance();

// Configure Ant Design message for better UX
message.config({
  top: 10, // Always at top of screen for maximum visibility
  duration: 6, // 6 seconds duration
  maxCount: 3,
  rtl: false,
  prefixCls: 'ant-message',
  getContainer: () => {
    // Create a dedicated container for messages at the top
    let container = document.getElementById('message-container-top');
    if (!container) {
      container = document.createElement('div');
      container.id = 'message-container-top';
      container.style.cssText = `
        position: fixed !important;
        top: 10px !important;
        left: 50% !important;
        transform: translateX(-50%) !important;
        z-index: 10001 !important;
        pointer-events: none !important;
        width: auto !important;
      `;
      document.body.appendChild(container);
    }
    return container;
  },
});

export default function App() {
  const [cookieConsent, setCookieConsent] = useState({ required: true, optional: false });
  const handleConsent = (consent) => {
    setCookieConsent(consent);
    if (consent.optional) {
      // Optional features like Google Analytics or Chat Widgets can be initialized here
     logger.log("Optional cookies accepted");
    }
  };
 
  return (
    <Provider store={store}>
      <ThemeProvider>
        <ReactKeycloakProvider
          authClient={keycloak}
          initOptions={{
            onLoad: "check-sso", // 🔹 Checks SSO but doesn't force login
            //redirectUri: window.location.origin, // 🔹 Ensures login happens in the same tab
            checkLoginIframe: false, // 🔹 Disables background login check for performance
          }}

          onEvent={(event, error) => {
            if (error) {
              console.error("Keycloak event error:", error); // ✅ Log Keycloak errors
            }
          }}
        >
          <AppContent />
          <CookieConsent onConsent={handleConsent} />
        </ReactKeycloakProvider>
      </ThemeProvider>
    </Provider>
  );
} 

  